var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModeltabInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.25C16 5.66632 15.8574 5.94596 15.552 6.25H2.39865C2.13642 5.96225 2 5.65446 2 5.25V4.5C2 3.5335 2.7835 2.75 3.75 2.75H14.25C15.2165 2.75 16 3.5335 16 4.5V5.25Z",
    stroke: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 13.5V8.75H15.25V13.5C15.25 14.4665 14.4665 15.25 13.5 15.25H4.5C3.5335 15.25 2.75 14.4665 2.75 13.5ZM6.75 9.25C6.05965 9.25 5.5 9.80963 5.5 10.5C5.5 11.1904 6.05965 11.75 6.75 11.75H11.25C11.9404 11.75 12.5 11.1904 12.5 10.5C12.5 9.80963 11.9404 9.25 11.25 9.25H6.75Z",
    stroke: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeltabInactive);
export default __webpack_public_path__ + "static/media/modeltabInactive.1105fb12493de068981d5d8dd055503c.svg";
export { ForwardRef as ReactComponent };